import React, { FC } from 'react';
import styled from 'styled-components';

const StyledText = styled.p`
  padding: 30px 0 0;
`;

interface TextProps {
  children: string;
}
const Text: FC<TextProps> = ({ children }) => (
  <StyledText>{children}</StyledText>
);

export default Text;
